if (!customElements.get('td-progress-bar')) {
  class TdProgressBar extends HTMLElement {
    constructor() {
      super();
      this.MODAL_ID = 'td-ala-modal';
    }
    connectedCallback() {
      this.pills = this.querySelectorAll('.td-progress-bar__step-pill');
      this.modalTrigger = this.querySelector(`[data-modal-trigger-id="${this.MODAL_ID}"]`);
      this.initializeListeners();
    }
    initializeListeners() {
      if (this.pills.length > 0) {
        document.addEventListener('rebuy.loaded', () => {
          document.addEventListener('rebuy:cart.change', this.handleCartChange.bind(this));
        });
      }
      if (this.modalTrigger) {
        this.modalTrigger.addEventListener('click', this.handleModalTriggerClick.bind(this));
      }
    }
    handleModalTriggerClick() {
      publish(`${this.MODAL_ID}:open`);
    }
    async handleCartChange(event) {
      setTimeout(() => {
      const items = Rebuy.Cart.items().map(item => {
        return {
          tags: item.product?.tags,
          quantity: item.quantity,
          discounts: item.discounts
        }});
      if (items.length > 0) {
        let quantity_progress = 0;
      
        for (const item of items) {
          if (item.tags?.includes('discounted') && item.discounts?.some(discount => !discount.title.includes('Gift'))  && !item.discounts?.some(discount => discount.title.includes('BYO'))) {
            quantity_progress += item.quantity;
          }
        }
        this.pills.forEach((pill, index) => {
          pill.classList.toggle('td-progress-bar__step-pill--active', index < quantity_progress);
        });
      } else {
        this.pills.forEach(pill => {
            pill.classList.remove('td-progress-bar__step-pill--active');
          });
        }
      }, 0);
    }
  }
  customElements.define('td-progress-bar', TdProgressBar);
}